import { type IPersistentStorage } from '@webapp/infrastructure/interfaces/services/IPersistentStorage'
import { type IGlobalSearchRecentsRepository } from '../../business-logic/interfaces/IGlobalSearchRecentsRepository'
import {
  GlobalSearchRecentItem,
  type GlobalSearchRecentItemConstructor,
} from '../../value-objects/GlobalSearchRecentItem'

const STORAGE_KEY = 'procurify.global-search.recent.v1'

interface StoredRecents {
  items: GlobalSearchRecentItemConstructor[]
}

interface Dependency {
  storage: IPersistentStorage
}

export class GlobalSearchRecentsRepository implements IGlobalSearchRecentsRepository {
  constructor(private readonly deps: Dependency) {}

  // eslint-disable-next-line @procurify/frontend-architecture-rules/repository-return-type -- grandfathered (PSERV-312): return the mapped GlobalSearchRecentItemConstructor payload instead and construct the value object in the Model layer, then delete this comment
  getAll(): GlobalSearchRecentItem[] {
    const stored = this.deps.storage.get<StoredRecents>(STORAGE_KEY)
    return (stored?.items ?? []).map((item) => new GlobalSearchRecentItem(item))
  }

  save(items: GlobalSearchRecentItem[]): void {
    this.deps.storage.set<StoredRecents>(STORAGE_KEY, { items })
  }
}
